import * as React from 'react';
import { connect } from 'react-redux';
import { ADD_REPLACEMENT_VALUE, CREDIT_HISTORY, PORTABLE_POSSESSIONS } from '../../../routes/routes';
import { ProgressBar} from 'react-bootstrap';
import { navigateTo } from '../../../actions/navigationActions';
import { setportablePossessionDescription } from '../../../actions/salesActions';
import './PortablePossessions.css';

class DescribePossession extends React.PureComponent<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            nextDisabled: true,
            possessionDescription: "",
            hasSubmitted: false,
            loggedIn: this.props.auth.uid ? true : false
        }
        this.handleChange = this.handleChange.bind(this);
        this.handleBack = this.handleBack.bind(this);
        this.handleNext = this.handleNext.bind(this);
    }

    async handleChange(e: any) {
        let name = e.target.name;
        let value = e.target.value;
        let nextTobeDisabled = true;
        if (value) {
            nextTobeDisabled = false;
        }
        await this.setState({ [name]: value });
        if (this.state.possessionDescription.length > 0) {
            await this.props.dispatchSetportablePossessionDescription(this.state.possessionDescription);
        }
        this.setState({ nextDisabled: nextTobeDisabled });
    }

    async handleBack(e: any) {
            this.props.redirectTo(PORTABLE_POSSESSIONS)
        }

    async handleNext() {
        await this.setState({ hasSubmitted: true });
        this.props.dispatchSetportablePossessionDescription(this.state.possessionDescription);
        this.props.redirectTo(ADD_REPLACEMENT_VALUE)
    }

    public render() {
        return (
            <div className={this.state.loggedIn ? "pt-lg-5 p-lg-0 logged-in" : "pt-lg-5 p-lg-05 logged-out"}>
                <div className="col-12 text-lg-center text-md-center">
                    <div className="container ssp-add-portable-possessions-replacement-value">
                        <div className="row justify-content-center mobile-mt-60px">
                            <div className="col-lg-12 col-md-12">
                                <div className="row justify-content-center">
                                    <div className="col-2 col-md-3 col-lg-3 col-xl-2 pt-lg-2 text-center align-self-center">
                                        <div className="BackRectangle d-none d-lg-block d-md-block">
                                            <button onClick={this.handleBack} className="Back cursor-pointer"><img src="./images/OnlineQuotation/icon-back-button-desktop.png" alt="" /></button>
                                        </div>
                                        <div className="sidenav d-lg-none d-md-none" id="mySidenav">
                                            <button onClick={this.handleBack} className="Back cursor-pointer" id="about"><img src="./images/OnlineQuotation/icons-navigation-quote-back-btn.png" alt="" /></button>
                                        </div>
                                    </div>
                                    <div className="col-10 col-md-9 col-lg-9 col-xl-10 p-0 text-center align-self-center">
                                        <div>
                                            <ProgressBar variant="success" now={35} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="container mt-32px mobile-mt-20px">
                        <div className="row justify-content-center">
                            <div className="col-lg-12 col-md-12 nopa">
                                <div className="row noma">
                                    <div className="col nopa"></div>
                                    <div className="col-lg-10 nopa">
                                        <div className="ssp-addportable-possessions-crown-icon mt-0px text-center">
                                            <div className="ssp-sales-journey-crown-icon" title="Add portable possessions"></div>
                                        </div>
                                        <div className="ssp-addreplacement-value-main-contentholder mt-21px mobile-mt-17px mb-28px mobile-mb-30px text-center ssp-addreplacement-value-p-holder">
                                            <div className="mb-6px font-size-16px font-weight-normal ssp-addreplacement-value-intro-header">
                                                Please describe your {this.props.sales.portablePossessionType} (make, model, brand, etc.)
                                            </div>
                                        </div>
                                        <div className="form-row noma ssp-addreplacement-value-tile-holder-row">
                                            <div className="col-12 nopa">
                                                <textarea placeholder="Tap here to start typing..." className="portable-text-area" value={this.state.possessionDescription} name="possessionDescription" onChange={this.handleChange} />
                                            </div>
                                        </div>
                                        <div className="row noma justify-content-center mt-40px">
                                            <div className="col-12 col-lg-4 nopa">
                                                <button type="submit" className="btn btn-block btn-solid-red cursor-pointer" id="NextButton" disabled={this.state.nextDisabled} onClick={this.handleNext}>Next</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        profile: state.profile,
        sales: state.sales,
        auth: state.firebase.auth,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        redirectTo: (des) => dispatch(navigateTo(des)),
        dispatchSetportablePossessionDescription: (description: string) => dispatch(setportablePossessionDescription(description)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(DescribePossession);
